<div class="container">
  <section class="left-side">
    <div
      class="left-side__illustration"
      [ngClass]="{
        'left-side__illustration--aocare001': addon === 'AOCARE001',
        'left-side__illustration--aocare002': addon === 'AOCARE002',
      }"
    >
      <div class="left-side__illustration__certified">
        <img src="/assets/img/icons/certified-waltio.svg" alt="certified-waltio" />
        <p class="body-14-med">{{ 'CERTIFIED_WALTIO_EXPERT' | translate }}</p>
      </div>
    </div>
  </section>
  <section class="right-side">
    <h1>{{ 'OUR_EXPERTS_CARE' | translate }}</h1>

    <div class="addons-options">
      <app-offer-toggle
        [type]="'ADDON'"
        [offer]="'AOCARE001'"
        [isChecked]="addon === 'AOCARE001'"
        [stablecoins]="stablecoins"
        [fiats]="fiats"
        [userPreferences]="userPreferences"
        (click)="toggleAddon('AOCARE001')"
      ></app-offer-toggle>
      <app-offer-toggle
        [type]="'ADDON'"
        [offer]="'AOCARE002'"
        [isChecked]="addon === 'AOCARE002'"
        [stablecoins]="stablecoins"
        [fiats]="fiats"
        [userPreferences]="userPreferences"
        (click)="toggleAddon('AOCARE002')"
      ></app-offer-toggle>
    </div>

    <p class="body-14">
      {{ addon + '.DESCRIPTION' | translate }}
    </p>

    <div class="addons-features">
      <div class="addons-features__item">
        <img width="14" height="14" src="/assets/img/icons/check-full.svg" alt="check-full" />
        <p class="body-14-med">{{ addon + '.FEATURE_1' | translate }}</p>
      </div>
      <div class="addons-features__item">
        <img width="14" height="14" src="/assets/img/icons/check-full.svg" alt="check-full" />
        <p class="body-14-med">{{ addon + '.FEATURE_2' | translate }}</p>
      </div>
      <div class="addons-features__item">
        <img width="14" height="14" src="/assets/img/icons/check-full.svg" alt="check-full" />
        <p class="body-14-med">{{ addon + '.FEATURE_3' | translate }}</p>
      </div>
      <div class="addons-features__item">
        <img width="14" height="14" src="/assets/img/icons/check-full.svg" alt="check-full" />
        <p class="body-14-med">{{ addon + '.FEATURE_4' | translate }}</p>
      </div>

      @if (addon === 'AOCARE002') {
        <div class="addons-features__item addons-features__item--bonus">
          <img width="14" height="14" src="/assets/img/icons/plus.svg" alt="plus" />
          <p class="body-14-med">{{ addon + '.FEATURE_5' | translate }}</p>
        </div>
      }
    </div>

    <div class="right-side__ctas">
      <div
        [matTooltip]="'ALREADY_SUB_ADDON' | translate"
        [matTooltipPosition]="'above'"
        [matTooltipDisabled]="
          (addon === 'AOCARE001' && availableAddons?.AOCARE001) || (addon === 'AOCARE002' && availableAddons?.AOCARE002)
        "
      >
        @if (
          (addon === 'AOCARE001' && availableAddons?.AOCARE001) || (addon === 'AOCARE002' && availableAddons?.AOCARE002)
        ) {
          <button type="button" mat-flat-button color="primary" (click)="openCheckoutDialog()">
            @if (paymentEstimate) {
              {{ 'SUBSCRIBE_FOR' | translate }}
              {{ paymentEstimate.due | currencyDecimal: userPreferences : stablecoins : fiats }}
            } @else {
              <img width="20px" class="rotating" src="/assets/img/icons/processing.svg" alt="" />
            }
          </button>
        } @else {
          <button type="button" mat-flat-button color="secondary" disabled>
            {{ 'SUBSCRIBE_FOR' | translate }}
            {{ (addon === 'AOCARE001' ? 799 : 2999) | currencyDecimal: userPreferences : stablecoins : fiats }}
          </button>
        }
      </div>

      <button type="button" mat-flat-button color="secondary" (click)="bookCall()">
        {{ 'SCHEDULE_CALL' | translate }}
      </button>
    </div>
  </section>
</div>
